<h2 mat-dialog-title>{{ "PASSENGERS.ASSIGNE.assignPassenger" | translate }}</h2>
<mat-dialog-content class="mat-typography">
    <div fxLayout="row" fxLayoutGap="10px" fxFlexFill>
        <div fxFlex fxLayout="column" fxLayoutGap="10px" fxFlexFill>
            <div fxFlex="25%">
                <mat-tab-group mat-align-tabs="center" dynamicHeight (selectedTabChange)="onSelectedTabChange($event)">
                    <mat-tab [label]="'PASSENGERS.ASSIGNE.searchByFlightCode' | translate">
                        <div class="pt-10" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-around center">
                            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                                <mat-label>{{ "PASSENGERS.ASSIGNE.flightCode" | translate }}</mat-label>
                                <input matInput [placeholder]="'PASSENGERS.ASSIGNE.flightCode' | translate" name="firstName" [formControl]="flightCodeFormControl" />
                                <mat-hint>{{ "PASSENGERS.ASSIGNE.flightCodeHelpText" | translate }}</mat-hint>
                                @if (flightCodeFormControl.hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                                @if (flightCodeFormControl.hasError("notValid")) {
                                    <mat-error> {{ "PASSENGERS.ASSIGNE.flightCodeNotValid" | translate }}</mat-error>
                                }
                            </mat-form-field>
                            <button fxFlex="30%" mat-raised-button color="primary" (click)="onSearchByFlightCode()">
                                {{ "GENERAL.search" | translate }}
                            </button>
                        </div>
                        <div fxFlex fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="space-around top">
                            <div
                                fxFlex
                                cdkDropList
                                #searchedPassengersList="cdkDropList"
                                [cdkDropListData]="searchedPassengers"
                                [cdkDropListConnectedTo]="[flightPassengersList]"
                                class="example-list"
                                (cdkDropListDropped)="drop($event)"
                            >
                                @for (item of searchedPassengers; track item) {
                                    <div class="example-box" cdkDrag>
                                        <div fxLayout="row" fxLayoutGap="10px" fxFlexFill>
                                            <div fxFlex style="text-align: center">{{ item.firstName }} {{ item.lastName }}</div>
                                            <mat-divider fxFlex="5%" [vertical]="true"></mat-divider>
                                            <div fxFlex style="text-align: center" class="mat-small">
                                                {{ item.dateOfBirth | date: "dd-MM-yyyy" }}
                                            </div>
                                            <mat-divider fxFlex="5%" [vertical]="true"></mat-divider>
                                            <div fxFlex style="text-align: center" class="mat-small">
                                                {{ item.gender }}
                                            </div>
                                            <mat-divider fxFlex="5%" [vertical]="true"></mat-divider>
                                            <div fxFlex style="text-align: center" class="mat-small">
                                                {{ item.nationalityId | nationality: "name" }}
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                            @if (searchedPassengers.length > 0) {
                                <button fxFlex="5%" mat-icon-button (click)="moveFilteredPassengerToFlightList(false)">
                                    <mat-icon>keyboard_arrow_right</mat-icon>
                                </button>
                            }
                        </div>
                        <mat-hint class="mat-small">{{ "PASSENGERS.ASSIGNE.dragAndDropHelpText" | translate }}</mat-hint>
                    </mat-tab>
                    <mat-tab [label]="'PASSENGERS.ASSIGNE.searchByPassengerName' | translate">
                        <div class="pt-10" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-around center">
                            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                                <mat-label>{{ "PASSENGERS.ASSIGNE.passengerName" | translate }}</mat-label>
                                <input
                                    type="text"
                                    [placeholder]="'PASSENGERS.ASSIGNE.passengerName' | translate"
                                    matInput
                                    name="passengerName"
                                    [formControl]="passengerNameFormControl"
                                    [matAutocomplete]="autoPassengerName"
                                />
                                <mat-autocomplete autoActiveFirstOption #autoPassengerName="matAutocomplete" (optionSelected)="onPassengerSelected($event)">
                                    @if (passengerNameIsLoading) {
                                        <mat-option class="is-loading">
                                            <mat-spinner diameter="50"></mat-spinner>
                                        </mat-option>
                                    }
                                    @if (!passengerNameIsLoading) {
                                        @for (option of filteredPassengersOptions; track option) {
                                            <mat-option [value]="option"> {{ option.firstName }} {{ option.lastName }} </mat-option>
                                        }
                                    }
                                </mat-autocomplete>
                                <mat-hint>{{ "PASSENGERS.ASSIGNE.passengerNameHelpText" | translate }}</mat-hint>
                                @if (passengerNameFormControl.hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                        </div>
                    </mat-tab>
                    <mat-tab [label]="'PASSENGERS.ASSIGNE.assigneNewPassenger' | translate">
                        <form #passengersForm="ngForm" fxFlex="100" (ngSubmit)="onNewPassengerFormSubmit()" [formGroup]="passengerFormGroup">
                            <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px" class="mt-15">
                                <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                                    <mat-label>{{ "PASSENGERS.UPDATE.firstName" | translate }}</mat-label>
                                    <input matInput [placeholder]="'PASSENGERS.UPDATE.firstName' | translate" name="firstName" formControlName="firstName" />
                                    @if (passengerFormGroup.controls["firstName"].hasError("required")) {
                                        <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                                    <mat-label>{{ "PASSENGERS.UPDATE.lastName" | translate }}</mat-label>
                                    <input matInput [placeholder]="'PASSENGERS.UPDATE.lastName' | translate" name="lastName" formControlName="lastName" />
                                    @if (passengerFormGroup.controls["lastName"].hasError("required")) {
                                        <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px" class="mt-15">
                                <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                                    <mat-label>{{ "PASSENGERS.UPDATE.gender" | translate }}</mat-label>
                                    <mat-select name="gender" formControlName="gender">
                                        <mat-option value="M">
                                            {{ "PASSENGERS.UPDATE.male" | translate }}
                                        </mat-option>
                                        <mat-option value="F">
                                            {{ "PASSENGERS.UPDATE.female" | translate }}
                                        </mat-option>
                                        <mat-option value="K">
                                            {{ "PASSENGERS.UPDATE.kid" | translate }}
                                        </mat-option>
                                        <mat-option value="I">
                                            {{ "PASSENGERS.UPDATE.infant" | translate }}
                                        </mat-option>
                                    </mat-select>
                                    @if (passengerFormGroup.controls["gender"].hasError("required")) {
                                        <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                                    <mat-label>{{ "PASSENGERS.UPDATE.dateOfBirth" | translate }}</mat-label>
                                    <input
                                        matInput
                                        [matDatepicker]="dateOfBirthPicker"
                                        [placeholder]="'PASSENGERS.UPDATE.dateOfBirth' | translate"
                                        name="dateOfBirth"
                                        formControlName="dateOfBirth"
                                        [max]="maxBirthDay"
                                    />
                                    <mat-datepicker-toggle matSuffix [for]="dateOfBirthPicker"> </mat-datepicker-toggle>
                                    <mat-datepicker #dateOfBirthPicker></mat-datepicker>
                                    @if (passengerFormGroup.controls["dateOfBirth"].hasError("matDatepickerParse")) {
                                        <mat-error> {{ "GENERAL.invalidDateFormat" | translate }}</mat-error>
                                    }
                                    @if (passengerFormGroup.controls["dateOfBirth"].hasError("required")) {
                                        <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="10px" class="pt-15">
                                <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                                    <mat-label>{{ "PASSENGERS.UPDATE.idCardNumber" | translate }}</mat-label>
                                    <input matInput [placeholder]="'PASSENGERS.UPDATE.idCardNumber' | translate" name="idCardNumber" formControlName="idCardNumber" />
                                    @if (passengerFormGroup.controls["idCardNumber"].hasError("required")) {
                                        <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                                    <mat-label>{{ "PASSENGERS.UPDATE.nationality" | translate }}</mat-label>
                                    <mat-select name="nationalityId" formControlName="nationalityId">
                                        @for (country of countries; track country) {
                                            <mat-option [value]="country.id">
                                                {{ country.name }}
                                            </mat-option>
                                        }
                                    </mat-select>
                                    @if (passengerFormGroup.controls["nationalityId"].hasError("required")) {
                                        <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <div style="text-align: right">
                                <button type="submit" mat-raised-button color="primary">
                                    {{ "GENERAL.create" | translate }}
                                </button>
                            </div>
                        </form>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
        <mat-divider fxFlex="0.5%" [vertical]="true"></mat-divider>
        <div fxFlex fxLayout="column" fxLayoutGap="10px" fxFlexFill>
            <div fxFlex="10%">
                <h2>{{ "PASSENGERS.ASSIGNE.flightPassengerList" | translate }}</h2>
            </div>
            <div fxFlex fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="space-around start">
                <div
                    fxFlex
                    cdkDropList
                    #flightPassengersList="cdkDropList"
                    [cdkDropListData]="flightPassengers"
                    [cdkDropListConnectedTo]="[searchedPassengersList]"
                    class="example-list"
                    (cdkDropListDropped)="drop($event)"
                >
                    @for (item of flightPassengers; track item; let index = $index) {
                        <div class="example-box" cdkDrag>
                            <div fxLayout="row" fxLayoutGap="0px" fxFlexFill fxLayoutAlign="center">
                                <div fxFlex style="text-align: center; vertical-align: middle; padding-top: 10px">{{ item.firstName }} {{ item.lastName }}</div>
                                <mat-divider fxFlex="1%" [vertical]="true"></mat-divider>
                                <div fxFlex style="text-align: center; padding-top: 10px" class="mat-small">
                                    {{ item.dateOfBirth | date: "dd-MM-yyyy" }}
                                </div>
                                <mat-divider fxFlex="1%" [vertical]="true"></mat-divider>
                                <div fxFlex style="text-align: center; padding-top: 10px" class="mat-small">
                                    {{ item.gender }}
                                </div>
                                <mat-divider fxFlex="1%" [vertical]="true"></mat-divider>
                                <div fxFlex style="text-align: center; padding-top: 10px" class="mat-small">
                                    {{ item.nationalityId | nationality: "name" }}
                                </div>
                                <mat-divider fxFlex="1%" [vertical]="true"></mat-divider>
                                <div fxFlex="10%" style="text-align: center">
                                    <button mat-icon-button color="warn" (click)="removePassenger(index)" [matTooltip]="'PASSENGERS.ASSIGNE.deletePassenger' | translate">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="warn" [mat-dialog-close]="true" cdkFocusInitial>
        {{ "GENERAL.cancel" | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="submitPassengersList()">
        {{ "GENERAL.save" | translate }}
    </button>
</mat-dialog-actions>
